// Подпись подложки поверх карты. Требование условий ОБОИХ поставщиков.
//
// Стоит в углу карты и кликается: у Яндекса это прямо записано («логотип должен
// быть гиперссылкой на главную страницу сайта Яндекс Карт»), у Carto ссылка
// ведёт на страницу правообладателей.
//
// Отступов СВОИХ у знака Яндекса нет: «область для отступов уже предусмотрена
// на изображениях с логотипами, дополнительные отступы проставлять не нужно».
// Поэтому знак прижат к углу вплотную, а поля создаёт сама картинка.

import { useLang } from '../../i18n'
import { activeBasemap } from '../baseStyle'
import { attributionView } from './attributionView'

interface Props {
  /** Угол карты. Любой из четырёх разрешён; по умолчанию правый нижний —
   *  там у наших карт нет ни легенды, ни кнопки загрузки. */
  corner?: 'bl' | 'br' | 'tl' | 'tr'
}

const CORNER: Record<NonNullable<Props['corner']>, string> = {
  bl: 'bottom-0 left-0',
  br: 'bottom-0 right-0',
  tl: 'top-0 left-0',
  tr: 'top-0 right-0',
}

export function BasemapAttribution({ corner = 'br' }: Props) {
  const { lang, t } = useLang()
  const view = attributionView(activeBasemap(), lang)
  // pointer-events-auto — свой: подпись кладут в оверлей карты с
  // pointer-events-none, и без этого клик проваливается на карту.
  const box = `pointer-events-auto absolute z-10 ${CORNER[corner]}`

  if (view.kind === 'logo') {
    return (
      <a
        className={box}
        href={view.href}
        target="_blank"
        rel="noreferrer noopener"
        aria-label={t(view.altKey)}
        title={t(view.altKey)}
        // Артворк поставщика вставляется как есть: перерисовывать и
        // перекрашивать его условия запрещают (п. 5.1.2).
        dangerouslySetInnerHTML={{ __html: view.svg }}
      />
    )
  }

  return (
    <a
      className={`${box} m-1 rounded bg-white/70 px-1.5 py-0.5 text-[10px] leading-tight text-slate-800 no-underline`}
      href={view.href}
      target="_blank"
      rel="noreferrer noopener"
    >
      {view.text}
    </a>
  )
}
